<template>
  <div
    :class="`bg-gradient-engineer-regist`"
  >
    <fade-transition :duration="100" origin="center top" mode="out-in">
      <router-view/>
    </fade-transition>
  </div>

</template>

<script>
    export default {
        name: "studentRegisterLayout",
        data() {
            return {};
        }
    };

</script>

<style scoped>
  .fit-page {
    height: 100vh;
  }
</style>